import React from 'react';
import styled from 'styled-components';
import {Link} from 'react-router-dom';
import {qurl} from '../lib/urlgen';
import FolderOpenIcon from '@mui/icons-material/FolderOpen';
import PersonIcon from '@mui/icons-material/Person';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';

const FlexCell = styled.div`
  width: 100%;
  padding: 8px;
  box-sizing: border-box;

  @media (min-width: 600px) {
    width: 50%;
  }

  @media (min-width: 960px) {
    width: 33.333%;
  }

  @media (min-width: 1440px) {
    width: 25%;
  }
`;

const Md3OutlinedCard = styled(Link)`
  display: flex;
  flex-direction: row;
  align-items: center;
  text-decoration: none;
  height: 100%;
  border-radius: 12px;
  border: 1px solid #c4c7c5;
  background-color: #f8fafd;
  overflow: hidden;
  transition:
    box-shadow 0.2s,
    background-color 0.2s;
  padding: 16px;
  font-family: 'odia', 'Roboto', sans-serif;
  color: #1d1b20;

  &:hover {
    box-shadow:
      0px 1px 3px 1px rgba(0, 0, 0, 0.15),
      0px 1px 2px 0px rgba(0, 0, 0, 0.3);
    background-color: #f0f4f9;
  }
`;

const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 16px;
  color: #0b57d0;
`;

const ContentContainer = styled.div`
  flex-grow: 1;
  display: flex;
  flex-direction: column;
`;

const Title = styled.h4`
  font-size: 16px;
  font-weight: 500;
  line-height: 1.4;
  margin: 0 0 4px 0;
  color: #1d1b20;
`;

const Subtitle = styled.div`
  font-size: 14px;
  color: #49454f;
`;

function getUrl(
  item: {name?: string; year?: number | string; bookCount?: number},
  type: string
) {
  if (type === 'authors') return qurl('ଲେଖକ', item.name);
  if (type === 'categories') return qurl('ବିଷୟ', item.name);
  if (type === 'years' && item.year !== undefined)
    return qurl('ବର୍ଷ', item.year.toString());
  return '';
}

function getIcon(type: string) {
  switch (type) {
    case 'authors':
      return <PersonIcon sx={{fontSize: 40, opacity: 0.8}} />;
    case 'years':
      return <CalendarTodayIcon sx={{fontSize: 40, opacity: 0.8}} />;
    case 'categories':
    default:
      return <FolderOpenIcon sx={{fontSize: 40, opacity: 0.8}} />;
  }
}

export function CollectionCard({
  item,
  type,
}: {
  item: {name?: string; year?: number | string; bookCount?: number};
  type: string;
}) {
  return (
    <FlexCell>
      <Md3OutlinedCard to={getUrl(item, type)}>
        <IconWrapper>{getIcon(type)}</IconWrapper>
        <ContentContainer>
          <Title>{item.name || item.year || ''}</Title>
          <Subtitle>
            {item.bookCount} {item.bookCount === 1 ? 'Book' : 'Books'}
          </Subtitle>
        </ContentContainer>
      </Md3OutlinedCard>
    </FlexCell>
  );
}
